import React, { useState, useEffect, useContext } from "react";
import { useFirestore } from "../../firebase/FirestoreContext";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../../elements/Header";
import { UserContext } from "../../context/UserContext";
import Footer from "../../elements/Footer";
import FAQ from "../../elements/FAQ";
import AddressForm from "../../elements/AddressForm";

const UserAddresses = () => {
  const navigate = useNavigate();
  const db = useFirestore();
  const { user } = useContext(UserContext);
  const location = useLocation();
  const userEmail = location.state?.userEmail; // Get the email from the location state

  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    if (!user) return;
    const userRef = doc(db, `Users/UsersList/DataBase`, user?.uid);
    const unsubscribe = onSnapshot(userRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        setAddresses(data.addresses || []);
      }
    });
    return () => unsubscribe();
  }, [db, user]);

  const saveAddress = async (address) => {
    if (!user) return;

    const userRef = doc(db, `Users/UsersList/DataBase`, user?.uid);
    const updatedAddresses = [...addresses];

    updatedAddresses.push(address);

    try {
      await updateDoc(userRef, { addresses: updatedAddresses });
      navigate("/useraccount");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  return (
    <div style={styles.container}>
      <Header search={false} />
      <div style={{ height: 35, borderBottom: "1px solid black", marginBottom: 20 }} />

      <div style={styles.content}>
        <div style={styles.title}>Add Address</div>
        <AddressForm onSave={saveAddress} onCancel={() => navigate("/useraccount")} existingEmail={user?.email} />
      </div>
      <FAQ />
      <Footer />
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "#fff",
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    marginTop: "20px",
    padding: "20px 20px 0",
    backgroundColor: "#fff",
    maxWidth: "1140px",
    margin: "0 auto"
  },
  title: {
    fontSize: "1.2rem",
    fontWeight: "600",
    marginBottom: 20,
  },
  editForm: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "14px",
    marginBottom: "5px",
  },
  input: {
    fontSize: "14px",
    padding: "10px",
    marginBottom: "15px",
    border: "1px solid #ddd",
  },
  autocompleteContainer: {
    marginBottom: "15px",
  },
  error: {
    color: "red",
    fontSize: "12px",
    marginBottom: "10px",
  },
};

export default UserAddresses;
